import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import { Dialog } from 'element-ui'
// 修改 el-dialog 默认点击遮照不关闭
Dialog.props.closeOnClickModal.default = false
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/global.css'
//import 'bootstrap/dist/css/bootstrap.css'单独建立一个H5的项目使用
import VueWechatTitle from 'vue-wechat-title' //动态修改title
Vue.use(VueWechatTitle)

// 导入需要注册为全局组件的组件
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'
import PermissionMethodRow from '@/components/button/PermissionMethodRow.vue'
import CustomerDetails from '@/components/CustomerDetails/index.vue'
import { appjs } from '@/utiljs/apputil'
// 注册全局组件
Vue.component('PermissionMethodToolbar', PermissionMethodToolbar)
Vue.component('PermissionMethodRow', PermissionMethodRow)
Vue.component('CustomerDetails', CustomerDetails)
// 全局日期格式化（用于 el-table-column）
Vue.prototype.$formatDateOnly = appjs.formatDateOnly
Vue.prototype.$tableDateFormatter = appjs.tableDateFormatter.bind(appjs)
//:formatter="$tableDateFormatter"
Vue.config.productionTip = false
Vue.use(ElementUI)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
